import type { AskAnswer } from "../api";

/** Older persisted answers only have a retrieval count. Zero is a real total. */
export function askAnswerStats(answer: AskAnswer): string {
  const records = (n: number) => `${n.toLocaleString("en-US")} ${n === 1 ? "record" : "records"}`;
  if (answer.countedRecordCount !== undefined) return `${records(answer.countedRecordCount)} counted`;
  if (answer.matchedRecordCount !== undefined) {
    const count = answer.matchedRecordCount.toLocaleString("en-US");
    const evidence = answer.evidenceRecordCount ?? 0;
    return `${answer.resultSets && answer.resultSets.length > 1 ? `${answer.resultSets.length} queries` : `${count} matching ${answer.matchedRecordCount === 1 ? "record" : "records"}`} · ${records(evidence)} provided to AI`;
  }
  // Legacy value counted matching text documents, not records read by the AI.
  return `${answer.matchedDocumentCount.toLocaleString("en-US")} search matches`;
}
